import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { Modal, Button } from "react-bootstrap";

const CustomModal = (props) => {
  const [show, setShow] = useState(false);

  const [othercontacts, setOtherContacts] = useState({
    name: "",
    email: "",
    phone_number: "",
    designation: "",
  });

  const [error, setError] = useState({});

  const inputChangeHandler = (evt) => {
    const { name, value } = evt.target;
    setOtherContacts((state) => {
      return {
        ...state,
        [name]: value,
      };
    });

    if (value.trim()) {
      let errors = { ...error };
      errors[name] = "";
      setError(errors);
    }
  };

  useEffect(() => {
    setOtherContacts((state) => {
      return {
        ...state,
        ...props.contactsEdit,
      };
    });
  }, [props.contactsEdit]);

  useEffect(() => {
    setShow(props.show);
    setError({});
  }, [props.show]);

  function getRandomColor() {
    return "#" + Math.floor(Math.random() * 16777215).toString(16);
  }
  function getContrastColor(hexColor) {
    // Convert hex to RGB
    const r = parseInt(hexColor.substring(1, 3), 16);
    const g = parseInt(hexColor.substring(3, 5), 16);
    const b = parseInt(hexColor.substring(5, 7), 16);
    // Calculate brightness (standard formula)
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    // Return white for dark backgrounds, black for light backgrounds
    return brightness > 200 ? "#000000" : "#FFFFFF";
  }

  // check the validation if name and mail is not empty and email is a valid email

  const checkValidation = () => {
    const errors = { ...error };
    let isValid = true;
    var filter =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (othercontacts.name.trim() === "") {
      errors.name = "Name can not be blank";
      isValid = false;
    }
    if (othercontacts.email.trim() === "") {
      errors.email = "Email can not be blank";
      isValid = false;
    }
    if (othercontacts.email.trim() && !filter.test(othercontacts.email)) {
      errors.email = "Email is not valid";
      isValid = false;
    }
    setError(errors);
    if (isValid) {
      setError({});
    }
    return isValid;
  };

  return (
    <Modal
      show={show}
      animation={true}
      backdrop={true}
      onHide={props.handleCloseModal}
    >
      <Modal.Header closeButton>{props.header}</Modal.Header>
      <form
        onSubmit={(evt) => {
          evt.preventDefault();

          if (!checkValidation()) {
            return;
          }
          const backgroundColor = getRandomColor();

          const textColor = getContrastColor(backgroundColor);

          setOtherContacts((state) => {
            return {
              name: "",
              email: "",
              phone_number: "",
            };
          });

          props.saveOtherContacts({
            ...othercontacts,
          });
          props.handleCloseModal();
        }}
      >
        <Modal.Body>
          <div className="side_modal_boady">
            <div className="form-group">
              <label htmlFor="">Company</label>
              <input
                type="text"
                className="form-control"
                disabled
                value={
                  (props.hasOwnProperty("company_name") &&
                    props.company_name) ||
                  ""
                }
                autoComplete="off"
              />
            </div>
            <div className="form-group">
              <label htmlFor="">
                Name <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="name"
                onChange={inputChangeHandler}
                value={othercontacts.name}
                autoComplete="off"
              />
              <span className="text-danger">{error.name}</span>
            </div>
            <div className="form-group">
              <label htmlFor="">
                Email <span>*</span>
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                onChange={inputChangeHandler}
                value={othercontacts.email}
                autoComplete="off"
              />
              <span className="text-danger">{error.email}</span>
            </div>
            {/* <div className="form-group">
              <label htmlFor="">Designation</label>
              <input
                type="text"
                className="form-control"
                name="designation"
                onChange={inputChangeHandler}
                value={othercontacts.designation}
                autoComplete="off"
              />
            </div> */}
            <div className="form-group">
              <label htmlFor="">Phone Number</label>
              <input
                type="number"
                className="form-control"
                name="phone_number"
                onChange={inputChangeHandler}
                value={othercontacts.phone_number}
                autoComplete="off"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-info"
            onClick={props.handleCloseModal}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button type="submit" variant="primary" className="border-0">
            Save
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default CustomModal;



// WEBPACK FOOTER //
// ./src/components/crm/modals/CustomModal.js